/* tslint:disable */
/* eslint-disable */
/**
 * My REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: jason.tai@octopus-tech.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SystemSetting
 */
export interface SystemSetting {
    /**
     * 
     * @type {number}
     * @memberof SystemSetting
     */
    bookBorrowMaxDay?: number;
    /**
     * 
     * @type {number}
     * @memberof SystemSetting
     */
    bookBorrowMaxResumeCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SystemSetting
     */
    bookBorrowResumeCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SystemSetting
     */
    bookBorrowResumeDay?: number;
    /**
     * 
     * @type {number}
     * @memberof SystemSetting
     */
    bookBorrowSameTime?: number;
    /**
     * 
     * @type {Date}
     * @memberof SystemSetting
     */
    memberCutOff?: Date;
    /**
     * 
     * @type {number}
     * @memberof SystemSetting
     */
    onlineReadSametime?: number;
    /**
     * 
     * @type {number}
     * @memberof SystemSetting
     */
    popularBooks?: number;
    /**
     * 
     * @type {number}
     * @memberof SystemSetting
     */
    recentlyReturned?: number;
    /**
     * 
     * @type {number}
     * @memberof SystemSetting
     */
    surpriseMe?: number;
    /**
     * 
     * @type {number}
     * @memberof SystemSetting
     */
    systemSettingId?: number;
}

export function SystemSettingFromJSON(json: any): SystemSetting {
    return SystemSettingFromJSONTyped(json, false);
}

export function SystemSettingFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemSetting {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bookBorrowMaxDay': !exists(json, 'bookBorrowMaxDay') ? undefined : json['bookBorrowMaxDay'],
        'bookBorrowMaxResumeCount': !exists(json, 'bookBorrowMaxResumeCount') ? undefined : json['bookBorrowMaxResumeCount'],
        'bookBorrowResumeCount': !exists(json, 'bookBorrowResumeCount') ? undefined : json['bookBorrowResumeCount'],
        'bookBorrowResumeDay': !exists(json, 'bookBorrowResumeDay') ? undefined : json['bookBorrowResumeDay'],
        'bookBorrowSameTime': !exists(json, 'bookBorrowSameTime') ? undefined : json['bookBorrowSameTime'],
        'memberCutOff': !exists(json, 'memberCutOff') ? undefined : (new Date(json['memberCutOff'])),
        'onlineReadSametime': !exists(json, 'onlineReadSametime') ? undefined : json['onlineReadSametime'],
        'popularBooks': !exists(json, 'popularBooks') ? undefined : json['popularBooks'],
        'recentlyReturned': !exists(json, 'recentlyReturned') ? undefined : json['recentlyReturned'],
        'surpriseMe': !exists(json, 'surpriseMe') ? undefined : json['surpriseMe'],
        'systemSettingId': !exists(json, 'systemSettingId') ? undefined : json['systemSettingId'],
    };
}

export function SystemSettingToJSON(value?: SystemSetting | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bookBorrowMaxDay': value.bookBorrowMaxDay,
        'bookBorrowMaxResumeCount': value.bookBorrowMaxResumeCount,
        'bookBorrowResumeCount': value.bookBorrowResumeCount,
        'bookBorrowResumeDay': value.bookBorrowResumeDay,
        'bookBorrowSameTime': value.bookBorrowSameTime,
        'memberCutOff': value.memberCutOff === undefined ? undefined : (value.memberCutOff.toISOString().substr(0,10)),
        'onlineReadSametime': value.onlineReadSametime,
        'popularBooks': value.popularBooks,
        'recentlyReturned': value.recentlyReturned,
        'surpriseMe': value.surpriseMe,
        'systemSettingId': value.systemSettingId,
    };
}

